if (!customElements.get('preorder-form')) {
  class PreorderForm extends HTMLElement {
    constructor() {
      super();
    }

    handleSuccessMessage(message) {
      const successContainer = this.querySelector('[js-success-message]');
      const errorContainer = this.querySelector('[js-error-message]');
      successContainer.innerHTML = message;
      successContainer.classList.remove('hidden');
      errorContainer.classList.add('hidden');
    }

    handleErrorMessage(message) {
      const successContainer = this.querySelector('[js-success-message]');
      const errorContainer = this.querySelector('[js-error-message]');
      errorContainer.innerHTML = message;
      errorContainer.classList.remove('hidden');
      successContainer.classList.add('hidden');
    }

    handleSubmit(event) {
      event.preventDefault();

      const modal = this.closest('support-modal');
      const variantId = modal.getAttribute('data-variant-id');

      if (!variantId) {
        this.handleErrorMessage(window.preorder.error);
        return;
      }

      const formData = new FormData();

      formData.set('variantId', variantId);
      formData.set(
        'customerId',
        this.querySelector('[name="customerId"]')?.value || '',
      );
      formData.set(
        'quantity',
        this.querySelector('[name="preorder[quantity]"]')?.value || 1,
      );

      this.submitButton.classList.add('disabled');

      fetch('/apps/preorder', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then((res) => res.json())
        .then((result) => {
          const draftOrderCreate = result?.body?.data?.draftOrderCreate;
          const userErrors = draftOrderCreate?.userErrors || [];

          if (!result.success || userErrors.length > 0) {
            this.handleErrorMessage(window.preorder.error);
            return;
          }

          const lineItem =
            draftOrderCreate?.draftOrder?.lineItems?.edges?.[0]?.node;

          const quantity = lineItem?.quantity || 0;
          const title = lineItem?.title || '';
          const variantTitle = lineItem?.variantTitle || '';

          const fullTitle = variantTitle ? `${title} - ${variantTitle}` : title;

          const successMessage = window.preorder.success
            .replace('[quantity]', quantity)
            .replace('[title]', fullTitle);

          this.handleSuccessMessage(successMessage);
        })
        .catch((err) => {
          this.handleErrorMessage(window.preorder.error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    connectedCallback() {
      this.submitButton = this.querySelector('[type="submit"]');

      this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
    }
  }

  customElements.define('preorder-form', PreorderForm);
}
